/*
 * «Scegli il reparto»: il riquadro N apre il reparto N della stessa navigazione
 * dell'header. Sotto 1200px apre il cassetto direttamente sul reparto; da 1200px
 * torna in cima e apre il mega pannello. Usa i componenti di Trade (header-drawer,
 * header-menu) simulando il clic sui loro <summary>, così focus e chiusura restano
 * quelli di Trade.
 */
class GmRepartiHome extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const pulsante = event.target.closest('[data-reparto]');
      if (!pulsante) return;
      this.apri(pulsante.dataset.reparto);
    });
  }

  apri(indice) {
    if (window.matchMedia('(min-width: 1200px)').matches) {
      this.apriPannello(indice);
    } else {
      this.apriCassetto(indice);
    }
  }

  apriPannello(indice) {
    const dettagli = document.getElementById(`Details-HeaderMenu-${indice}`);
    if (!dettagli) return;
    const ridotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: ridotto ? 'auto' : 'smooth' });
    const summary = dettagli.querySelector('summary');
    if (!dettagli.open) summary.click();
    summary.focus({ preventScroll: true });
  }

  apriCassetto(indice) {
    const cassetto = document.getElementById('Details-menu-drawer-container');
    const reparto = document.getElementById(`Details-menu-drawer-menu-item-${indice}`);
    if (!cassetto || !reparto) return;
    if (!cassetto.open) cassetto.querySelector('summary').click();
    // Trade apre il cassetto con un setTimeout: il sottomenu va aperto dopo.
    setTimeout(() => {
      if (!reparto.open) reparto.querySelector('summary').click();
    }, 150);
  }
}

if (!customElements.get('gm-reparti-home')) customElements.define('gm-reparti-home', GmRepartiHome);
